import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SharedService } from 'src/app/shared/services/shared.service';
import { FaqService } from './faq.service';
import { HighlightPipe } from 'src/app/shared/pipes/highlight.pipe';

@Component({
    selector: 'app-faq',
    templateUrl: './faq.component.html',
    styleUrl: './faq.component.scss',
    standalone: true,
    imports: [FormsModule, HighlightPipe]
})
export class FaqComponent implements OnInit {
  searchTerm: string = '';
  loading: boolean = false;

  constructor(
    public sharedService: SharedService,
    private faqService: FaqService
  ) {}

  ngOnInit() {
    this.faqService.loadFAQs();
  }

  onSearchChange() {
    if (this.searchTerm.trim()) {
      this.faqService.searchFAQs(this.searchTerm).subscribe({
        next: (response) => {
          this.faqService.faqItems = response.data;
        },
        error: (error) => {
          console.error('Error searching FAQs:', error);
        },
      });
    } else {
      this.faqService.loadFAQs();
    }
  }

  clearSearch() {
    this.searchTerm = '';
    this.faqService.loadFAQs();
  }

  get filteredFaqItems() {
    return this.faqService.faqItems;
  }

}
